export default "__VITE_ASSET__BivNCx2T__"